"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const R = react_1.default.createElement;
const expressions_ui_1 = require("@mwater/expressions-ui");
const expressions_1 = require("@mwater/expressions");
const DashboardUtils = __importStar(require("../dashboards/DashboardUtils"));
// Designer for popup filter joins (see PopupFilterJoins.md)
class PopupFilterJoinsEditComponent extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false
        };
    }
    handleExprChange = (table, expr) => {
        let design = this.props.design || this.props.defaultPopupFilterJoins;
        design = lodash_1.default.clone(design);
        design[table] = expr;
        return this.props.onDesignChange(design);
    };
    render() {
        if (!this.state.expanded) {
            return R("a", { className: "btn btn-link", onClick: () => this.setState({ expanded: true }) }, T `Advanced Popup Options`);
        }
        // Get filterable tables of popup
        const popupDashboard = { items: this.props.popup.items, layout: "blocks" };
        let filterableTables = DashboardUtils.getFilterableTables(popupDashboard, this.props.schema);
        // Always include self as first
        filterableTables = [this.props.table].concat(lodash_1.default.without(filterableTables, this.props.table));
        // Get popupFilterJoins
        const popupFilterJoins = this.props.design || this.props.defaultPopupFilterJoins;
        return R("div", null, R("div", { className: "text-muted" }, T `Optional connections for other tables to filtering the popup`), R("table", { className: "table table-sm table-bordered" }, R("thead", null, R("tr", null, R("th", null, T `Data Source`), R("th", null, T `Connection`))), R("tbody", null, lodash_1.default.map(filterableTables, (filterableTable) => {
            return R("tr", { key: filterableTable }, R("td", { style: { verticalAlign: "middle" } }, expressions_1.ExprUtils.localizeString(this.props.schema.getTable(filterableTable)?.name)), R("td", null, R(expressions_ui_1.ExprComponent, {
                schema: this.props.schema,
                dataSource: this.props.dataSource,
                table: filterableTable,
                value: popupFilterJoins[filterableTable],
                onChange: this.handleExprChange.bind(null, filterableTable),
                types: this.props.table === this.props.idTable ? ["id", "id[]"] : ["id"], // TODO support id[] some day for admin choropleth maps too
                idTable: this.props.idTable,
                preferLiteral: false,
                placeholder: T `None`
            })));
        }))));
    }
}
exports.default = PopupFilterJoinsEditComponent;
